"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var EVENTS = {
  ON_ITEM_CREATED: 'ON_ITEM_CREATED',
  ON_GALLERY_CHANGE: 'ON_GALLERY_CHANGE',
  ON_ITEM_ACTION_TRIGGERED: 'ON_ITEM_ACTION_TRIGGERED',
  ON_CURRENT_ITEM_CHANGED: 'ON_CURRENT_ITEM_CHANGED',
  ON_ITEM_CLICKED: 'ON_ITEM_CLICKED',
  //for bi report only
  ON_DOWNLOAD_BUTTON_CLICKED: 'ON_DOWNLOAD_BUTTON_CLICKED',
  //for Bi report only
  ON_BUY_NOW_CLICKED: 'ON_BUY_NOW_CLICKED',
  //for Bi report only
  ON_THUMBNAIL_CLICKED: 'ON_THUMBNAIL_CLICKED',
  //for Bi report only
  NEED_MORE_ITEMS: 'NEED_MORE_ITEMS'
};
var _default = EVENTS;
exports["default"] = _default;